import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { InvoiceViewComponent } from './invoice-view.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [InvoiceViewComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: InvoiceViewComponent
      }
    ]),
    TranslateModule.forChild()
  ],
  exports: [InvoiceViewComponent]
})
export class InvoiceViewModule { }
